// 月初现金余额管理
export default {
  interOrderPool: {
    search: {
      orderDateStart: '日期从',
      orderDateEnd: '日期到',
    },
    column: {
      orderCompany: '公司',
      orderDepartment: '部门',
      orderDate: '日期',
      order: '业务单据类型',
      event: '操作类型',
      orderNo: '业务单据编号',
      orderAmount: '计息金额',
      paymentAmount: '计息金额(+)',
      receiptAmount: '计息金额(-)',
      remark: '备注',
      financingAmount: '贸易融资金额',
      interestAmount: '资金利息',
    },
    placeholder: {
      orderCompanyPlaceholder: '请选择公司',
      orderDepartmentPlaceholder: '请选择部门',
      orderDatePlaceholder: '请选择日期',
      orderPlaceholder: '请选择业务单据类型',
      eventPlaceholder: '请选择操作类型',
      financingAmountPlaceholder: '请输入贸易融资金额',
      interestAmountPlaceholder: '请输入资金利息',
    },
    button: {
      save: '保存',
      add: '新增',
      delete: '删除',
    },
    message: {
      noSelected: '您还未选择任何数据!',
      noForbid: '失效状态不能编辑！',
      onlyOneSelectData: '请选择一条数据进行操作!',
      noExport: '当前没有数据可以导出！',
      saveSussess: '保存成功！',
      saveFail: '保存失败！',
      select: '请选择一条数据操作，或直接点击行数据编辑',
      noCanDelSelectData: '所选数据中没有手动创建的数据，请重新选择！',
      hasCannotDelTip: '所选数据中有不可删除的数据，点击确认只会删除手动创建的数据！',
      noCanCal: '所选数据已计息，请重新选择！',
    },
  },
};
